import React, { useState, useRef, useCallback, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Spinner from '../../components/Spinner';

import NoDataTrips from '../../../sass/images/no-data-trips.svg';

export default function DynamicTable({
    columns = [],
    data = [],
    pageSize = 20,
    loading = false,
    titleTranslate = (v) => v,
}) {
    const [visibleCount, setVisibleCount] = useState(pageSize);
    const scrollRef = useRef(null);

    useEffect(() => {
        setVisibleCount(pageSize);
    }, [data.length, pageSize]);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;
        if (visibleCount < data.length && el.scrollHeight <= el.clientHeight) {
            setVisibleCount((prev) => Math.min(prev + pageSize, data.length));
        }
    }, [visibleCount, data.length, pageSize]);

    const handleScroll = useCallback(() => {
        const el = scrollRef.current;
        if (!el) return;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50) {
            setVisibleCount((prev) => Math.min(prev + pageSize, data.length));
        }
    }, [data.length, pageSize]);

    if (loading) {
        return (
            <Spinner> </Spinner>
        );
    }

    const isEmpty = !data || data.length === 0;

    return (
        <Container className="main-card card-maintenances vehicle block-hidden driver">
            {isEmpty ? (
                <div className="ant-empty" style={{ padding: "40px", textAlign: "center" }}>
                    <div>
                        <img src={NoDataTrips} alt="no data" style={{ width: '100%',  maxwidth: '500px', height: '100%',maxHeight: '500px' }}/>
                    </div>
                    <div className="ant-empty-description m-2">No se encontraron viajes</div>
                </div>
            ) : (
                <>
                    <Row
                        ref={scrollRef}
                        onScroll={handleScroll}
                        className="no-gutters driver table-responsive"
                        style={{ maxHeight: '70vh', overflowY: 'auto' }}
                    >
                        <table className="table table-hover">
                            <thead className="table-drivers">
                                <tr>
                                    {columns.map((col, index) => (
                                        <th
                                            key={index}
                                            scope="col"
                                            className={col.desktopOnly ? "table-desktop" : ""}
                                        >
                                            {titleTranslate(col.title)}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {data
                                    .slice(0, visibleCount)
                                    .map((item, rowIndex) => (
                                        <tr key={item.id || rowIndex}>
                                            {columns.map((col, colIndex) => (
                                                <td
                                                    key={colIndex}
                                                    className={col.desktopOnly ? "table-desktop" : ""}
                                                >
                                                    {col.render
                                                        ? col.render(item)
                                                        : item[col.dataIndex]}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </Row>

                    {visibleCount < data.length && (
                        <div className="col-12 m-2 text-center">
                            <Spinner />
                        </div>
                    )}
                </>
            )}
        </Container>
    );
}
